import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Search, Loader2, Plus } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const AddressSearch = ({ onImported }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [busy, setBusy] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (q.length < 3) return setRes([]);
    const t = setTimeout(() => api.get("/pdok/suggest", { params: { q } }).then((r) => setRes(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);

  const pick = async (s) => {
    setBusy(s.id);
    try {
      const { data } = await api.post("/addresses/import", { ls_id: s.id });
      toast.success(`${data.weergavenaam} gekoppeld aan perceel ${data.perceel?.aanduiding || "–"}`);
      setQ("");
      onImported?.();
      nav(`/adressen/${data.id}`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="relative">
      <Search className="absolute left-3 top-3 h-4 w-4 text-slate-500" />
      <Input data-testid="search-address-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Zoek adres in BAG (bv. Kerkstraat 12 Utrecht of 3511AB 12)" className="pl-9 h-10 bg-slate-950 border-slate-800" />
      {res.length > 0 && (
        <div className="absolute z-[1100] mt-1 w-full rounded-md border border-slate-700 bg-slate-900/95 backdrop-blur-md shadow-xl overflow-hidden" data-testid="search-results">
          {res.map((s, i) => (
            <button key={s.id} data-testid={`search-result-${i}`} onClick={() => pick(s)} disabled={!!busy}
              className="w-full flex items-center justify-between px-3 py-2.5 text-sm hover:bg-blue-600/20 text-left">
              {s.weergavenaam}
              {busy === s.id ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4 text-slate-500" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
